import React, { useState, type CSSProperties } from 'react';
import { Box, Button, Typography, Paper, Divider, Grid } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DoneIcon from '@mui/icons-material/Done';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import WarningIcon from '@mui/icons-material/Warning';
import MouseIcon from '@mui/icons-material/Mouse';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import EditIcon from '@mui/icons-material/Edit';
import './styles.css';


const Bstyle: (BGcolor: string) => CSSProperties = (BGcolor: string) =>{ 
  const ButtonStyle : CSSProperties = { padding: '0.5rem',width: '2rem', height: '2rem', borderRadius: '0.5rem',
    backgroundColor:BGcolor ,color: 'white',fontWeight: 'bold',border: 'none',
    cursor: 'pointer',transition: 'background-color 0.3s ease', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    display: 'flex',  alignItems: 'center', justifyContent: 'center',fontSize: '1rem',userSelect:'none'
  }
  return ButtonStyle
};

const IconA = ()=>{return (<div  title="Aggiorna Anagrafica" style={Bstyle('#173a80ff')}>A</div>)};
const IconSwap = ()=>{return (<div title="Cliente / Fornitore" style={ Bstyle('#305fa5ff')}><SwapHorizIcon style={{ fontSize: '1rem' }} /></div>)};
const IconExchange = ()=>{return (<div  title="Cambio valuta" style={ Bstyle('#305fa5ff')}><CurrencyExchangeIcon style={{ fontSize: '1rem' }} /></div>)};
const IconEdit= ()=>{return (<div  title="Modifica XML" style={ Bstyle('#305fa5ff')}><EditIcon style={{ fontSize: '1rem' }} /></div>)};

// Interfaccia per le props del NextButton
interface NextButtonProps {
  currentStep: number;
  onNext: (nextStep: number) => void; // Funzione che accetta il prossimo numero di passo
  onFinish: () => void; // Funzione per chiudere il tutorial
}

// Interfaccia per le props del componente principale
interface PdfHelperTutorialProps {
  isVisible: boolean;
  onClose: () => void;
}

// Interfaccia per i dati di un singolo passo del tutorial
interface TutorialStep {
    title: string;
    icon: React.ReactNode;
    description: React.ReactNode;
    imagePlaceholder: string;
}

interface TutorialIndexProps {
    steps: TutorialStep[];
    currentStep: number;
    onSelectStep: (step: number) => void;
}

// Componente Principale 
export const PdfHelperTutorial: React.FC<PdfHelperTutorialProps> = ({ isVisible, onClose }) => {

  const [showIconSwap, setShowIconSwap] = useState(false); 
  const [showIconExchange, setShowIconExchange] = useState(false); 
  const [showIconEdit, setShowIconEdit] = useState(false); 
  const [showIconA, setShowIconA] = useState(false)


// Contenuto del Tutorial 
const TUTORIAL_STEPS = [
  {
    title: "1. Zoom ",
    icon: <ZoomInIcon fontSize="large" color="primary" />,
    description: (
      <>
        Per cambiare il livello di ingrandimento del PDF:
        <br />
        <Box component="span" fontWeight="bold">Usa la rotellina del mouse:</Box> Scorri la rotellina del mouse verso l'alto o il basso mentre il puntatore è sopra il PDF.
        </>
    ),
    imagePlaceholder: "",
  },
  {
    title: "2. Navigazione",
    icon: <MouseIcon fontSize="large" color="primary" />,
    description: (
      <>
        Se il documento è ingrandito e non entra nel riquadro:
        <br />
        <Box component="span" fontWeight="bold">Tieni premuto Ctrl + Tasto sinistro del mouse</Box>, trascina per spostare il PDF e visualizzare altre aree.
      </>
    ),
    imagePlaceholder: "",
  },
  {
    title: "3. Selezione del Testo",
    icon: <TextFieldsIcon fontSize="large" color="primary" />,
    description: (
      <>
        <Box>Se il <strong>PDF</strong> è un documento <strong>scansionato</strong> sarà contrassegnato nella lista a sinistra con l'icona: <WarningIcon style={{ color:'#21659cff', fontSize: '1.25rem' }} /> . </Box>
        Un PDF scansionato <strong>non ha testo selezionabile</strong> e richiede maggiore attenzione, poiché i dati estratti <strong>potrebbero</strong> contenere <strong style={{color:'#cc1111ff'}}>errori o scritte poco leggibili</strong>.
        <br /><br />
        I <strong>PDF digitali</strong>, invece, permettono la selezione del testo (clic con il tasto sinistro del mouse).
        I dati estratti dai file digitali sono generalmente ottimi, ma è sempre una buona pratica <strong>controllare</strong> il risultato prima di scaricare il documento XML completo.
      </>
    ),
    imagePlaceholder: "",
  },
  {
    title:"4. Modifica e Strumenti",
    icon:"",
    description:(
      <>
        I dati estratti dal PDF possono essere modificati singolarmente o tramite funzioni dedicate che semplificano alcune operazioni.
        <br/><br/>
        Quando elabori la fattura di un <strong>nuovo cliente</strong>, ti verrà <strong>automaticamente</strong> chiesto di salvare la sua anagrafica.
        <br />
        <strong>Salvare l'anagrafica</strong> garantisce che <strong>i dati del cliente</strong> siano sempre  <strong>corretti e coerenti</strong> nelle elaborazioni future.
        <br />
        <div style={{display:'flex', justifyContent:'flex-start', textAlign:'left', flexDirection:'column', marginTop:'1rem'}}>
          Strumenti di modifica :
          <div style={{display:'flex', justifyContent:'center', flexDirection:'row'}}>
            <button 
              style={{border:0, backgroundColor:'#fff', margin:'0.3rem 0.5rem 1rem 0'}}
              onClick={()=>{setShowIconSwap(false); setShowIconExchange(false); setShowIconEdit(false); setShowIconA(true)}}
            >
             <IconA/>
            </button>
            <button 
              style={{border:0, backgroundColor:'#fff',margin:'0.3rem 0.5rem 1rem 0'}}
              onClick={()=>{setShowIconA(false); setShowIconExchange(false); setShowIconEdit(false); setShowIconSwap(true)}}
            >
              <IconSwap/>
            </button>
            <button 
              style={{border:0, backgroundColor:'#fff', margin:'0.3rem 0.5rem 1rem 0'}}
              onClick={()=>{setShowIconA(false); setShowIconEdit(false); setShowIconSwap(false); setShowIconExchange(true)}}
            >
              <IconExchange/>
            </button>
            <button 
              style={{border:0, backgroundColor:'#fff', margin:'0.3rem 0 1rem 0'}}
              onClick={()=>{setShowIconA(false); setShowIconExchange(false); setShowIconSwap(false); setShowIconEdit(true)}}
            >
              <IconEdit/>
            </button>
          </div>
          <div>
            {!showIconA && !showIconSwap && !showIconExchange && !showIconEdit &&(
              <Box>
                <Divider sx={{mb:'1rem'}}/>
                <div style={{display:'flex', justifyContent:'center', padding:'0 1rem 0 1rem', fontWeight:600, fontSize:20, color:'#a1a1a1ff'}}>Clicca un icona</div>
              </Box>
            )}
            {showIconA && (
              <Box>
                <Divider sx={{mb:'1rem'}}/>
                <div style={{padding:'1rem', backgroundColor:'#f2f2f3ff', borderRadius:'6px', border:'1px dashed #ccc'}}>
                  <strong>Serve a salvare o a ricontrollare i dati di un cliente.</strong><br/>
                  Se l'anagrafica del cliente <strong>esiste già</strong> e i dati estratti contengono errori (es. indirizzo errato), puoi cliccare su <div style={{display:'flex'}}> <IconA/> <div style={{margin:'0 0.3rem 0 0.4rem'}}>per</div> <strong>ricaricare automaticamente i dati corretti</strong></div> precedentemente salvati.<br/><br/>
                  <strong style={{color:'#d81010ff'}}>Nota Importante:</strong> L'anagrafica di un cliente è riconosciuta dal sistema tramite la <strong>Partita IVA</strong>.<br/> Assicurati sempre che <strong>la Partita IVA sia corretta prima di salvare o ricontrollare i dati.</strong>
                </div>
              </Box>
            )}
            {showIconSwap && (
              <Box>
                <Divider sx={{mb:'1rem'}}/>
                <div style={{padding:'1rem', backgroundColor:'#f2f2f3ff', borderRadius:'6px', border:'1px dashed #ccc'}}>
                  A volte, specialmente con PDF scansionati o poco chiari, il sistema può scambiare i dati del <strong>Fornitore</strong> con quelli del <strong>Cliente</strong>.<br/> Questa funzionalità serve, quindi, a scambiare l'anagrafica del fornitore con l'anagrafica del cliente e viceversa. <br/><br/>
                  <strong style={{color:'#d81010ff'}}>Esempio pratico in caso di errore: </strong><br/>
                    <span style={{display:'flex', marginLeft:'0.5rem', marginTop:'1rem'}}><div style={{marginRight:'0.3rem'}}>1.</div> <div>Se il sistema ti chiede di salvare un'anagrafica che sai essere errata (perché ha scambiato i ruoli), <strong>clicca su Annulla</strong>.</div></span><br/>
                    <span style={{display:'flex', marginLeft:'0.5rem'}}>2.  Clicca sull'icona <div style={{margin:'0 0.3rem 0 0.3rem'}}><IconSwap/></div>per scambiare i dati.</span><br/>
                    <span style={{display:'flex', marginLeft:'0.5rem'}}>3.  Infine, clicca <div style={{margin:'0 0.3rem 0 0.3rem'}}><IconA/></div>per salvare l'anagrafica corretta.</span><br/>
                </div>
              </Box>
            )}
            {showIconExchange && (
              <Box>
                <Divider sx={{mb:'1rem'}}/>
                <div style={{padding:'1rem', backgroundColor:'#f2f2f3ff', borderRadius:'6px', border:'1px dashed #ccc'}}>
                  Questa funzione è necessaria se la fattura è emessa in una valuta diversa dall'Euro.<br />
                  In realta il cambio valuta viene calcolato <strong>automaticamente</strong> durante l'elaborazione iniziale, ma 
                  questa funzionalità è utile se la <strong>data</strong>, <strong>l'importo</strong> o la <strong>valuta</strong> sono stati estratti in modo errato, permettendoti di <strong>ricalcolare</strong> il cambio valuta.<br/><br/>
                  <strong style={{color:'#d81010ff'}}>Nota:</strong> per calcolare il cambio utiliziamo i dati forniti da <strong>{`Banca d'Italia`}.</strong>
                </div>
              </Box>
            )}
            {showIconEdit && (
            <Box> 
              <Divider sx={{mb:'1rem'}}/>
              <div style={{padding:'1rem', backgroundColor:'#f2f2f3ff', borderRadius:'6px', border:'1px dashed #ccc'}}>
                Permette di visualizzare <strong>{`l'anteprima del file XML`}</strong> del singolo documento corrente.<br/>
                In questa modalità puoi modificare anche altri valori specifici dell'XML e scaricare il file XML singolarmente.<br/><br/>
                <strong>⚠️ Attenzione:</strong><br/> Le modifiche apportate qui sono valide <strong>solo ed esclusivamente per il singolo file</strong> che stai visualizzando e <strong>non influenzeranno</strong> la struttura generale utilizzata per creare gli XML.<br/>
                Dopo l'uscita dall'anteprima, gli unici valori che vengono aggiornati (solo se hai premuto <strong>SALVA</strong> all'interno dell'anteprima) sono quelli che corrispondono ai valori estratti.
              </div>
            </Box>
            )}
          </div>
        </div>
      </>
    ),
    imagePlaceholder:"",
  }
];

// indice di navigazione del tutorial.
const TutorialIndex: React.FC<TutorialIndexProps> = ({ steps, currentStep, onSelectStep }) => {
    return (
        <Box sx={{ mb: 2, p: 1, border: '1px solid #e0e0e0', borderRadius: 1, bgcolor: '#f5f5f5' }}>
            <Grid container spacing={1}>
                {steps.map((step, index) => {
                    const stepNumber = index + 1;
                    const isActive = stepNumber === currentStep;
                    return (
                        <div key={(step.title).slice(0,12)} > 
                            <Button
                                size="small"
                                variant={isActive ? "contained" : "text"}
                                color="primary"
                                onClick={() => onSelectStep(stepNumber)}
                                sx={{ 
                                    textTransform: 'none', 
                                    minWidth: 'auto',
                                    fontWeight: isActive ? 'bold' : 'normal',
                                    justifyContent: 'flex-start',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    width: '100%',
                                    // Stile per il link inattivo
                                    ...(isActive ? {} : { color: 'text.secondary', '&:hover': { bgcolor: 'primary.light', color: 'white' } }),
                                }}
                            >
                                {step.title=='3. Selezione del Testo'? '3. Selezione...': step.title =='4. Modifica e Strumenti'? '4. Modifica...': step.title }
                            </Button>
                        </div>
                    );
                })}
            </Grid>
        </Box>
    );
};

// Freccetta
const NextButton: React.FC<NextButtonProps> = ({ currentStep, onNext, onFinish }) => {
  const isLastStep = currentStep === TUTORIAL_STEPS.length;
  const nextStepIndex = currentStep + 1;

  const handleClick = () => {
    if (isLastStep) {
      onFinish(); // Chiudi l'helper
    } else {
      onNext(nextStepIndex); // Passa al prossimo step
    }
  };

  return (
    <Box sx={{ mt:4.5, mb: 3, textAlign: 'center' }}>
      <Button
        variant="contained"
        endIcon={isLastStep ? <DoneIcon /> : <ArrowDownwardIcon />}
        onClick={handleClick}
        color={isLastStep ? "success" : "primary"}
        size="large"
      >
        {isLastStep ? "Ho Capito!" : `Avanti`}
      </Button>
    </Box>
  );
};


// Funzione per la navigazione all'indice
  const handleStepSelect = (step: number) => {
    setCurrentStep(step);
    // Resetta la visualizzazione dei tool quando si cambia passo
    setShowIconA(false);
    setShowIconSwap(false);
    setShowIconExchange(false);
    setShowIconEdit(false);
  };

  // Inizia dal Passo 1
  const [currentStep, setCurrentStep] = useState(1); 

  if (!isVisible) return null;

  const stepData = TUTORIAL_STEPS[currentStep - 1];

  // Resetta lo stato quando l'helper viene chiuso
  const handleClose = () => {
    setCurrentStep(1); 
    // Resetta anche i tool
    setShowIconA(false);
    setShowIconSwap(false);
    setShowIconExchange(false);
    setShowIconEdit(false);
    onClose();
  };

  const handleNext = (nextStep:number) => {
    setCurrentStep(nextStep);
    // Resetta anche i tool
    setShowIconA(false);
    setShowIconSwap(false);
    setShowIconExchange(false);
    setShowIconEdit(false);
  };

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        padding: '0 3rem 0 3rem', 
        maxWidth: 550, 
        margin: '20px auto', 
        position: 'relative',
        borderRadius: 2
      }}
    >
      <TutorialIndex
        steps={TUTORIAL_STEPS}
        currentStep={currentStep}
        onSelectStep={handleStepSelect}
      />
      <Divider sx={{ mb: 3 }} />

      {/* Contenuto del Passo Corrente */}
      <Grid container spacing={2} alignItems="center">
        <div style={{ textAlign: 'center' }}>
          {stepData.icon}
        </div>
        <div>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {stepData.title}
          </Typography>
        </div>
      </Grid>
      
      <Box sx={{ mt: 2, mb: 3 }}>
        <Typography variant="body1" component="div" fontFamily='Segoe UI'>
          {stepData.description}
        </Typography>
      </Box>

      {/* Segnaposto Immagine */}
      {stepData.imagePlaceholder && (
        <Box 
          sx={{ 
            height: 150, 
            bgcolor: 'grey.200', 
            borderRadius: 1, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            border: '1px dashed grey' 
          }}
        >
          <Typography variant="caption" color="text.secondary">
            {stepData.imagePlaceholder} 
          </Typography>
        </Box>
      )}

      {/* Pulsante di Navigazione */}
      <NextButton 
        currentStep={currentStep} 
        onNext={handleNext} 
        onFinish={handleClose} 
      />
      
    </Paper>
  );
};

export default PdfHelperTutorial;